export type SupporterImportColumnsArgs = {
  showAddress2: boolean
  editFederalDistrict: boolean
}

// The supported attributes are listed in `Sanitizers::Supporter`
export function supporterImportColumns({ showAddress2, editFederalDistrict }: SupporterImportColumnsArgs) {
  const address2Column = {
    column_name: 'street_address_2',
    display_label: 'Unit / Apartment',
    matching_keywords: 'street_address_2, address_2, address2',
    type: 'text',
    required: false,
  }

  const federalDistrictColumn = {
    column_name: 'federal_district',
    display_label: 'Federal district',
    matching_keywords: 'federal_district, federal district',
    type: 'text',
    required: false,
  }

  return [
    {
      column_name: 'first_name',
      display_label: 'First name',
      matching_keywords: 'first_name',
      type: 'text',
      required: true,
    },
    {
      column_name: 'last_name',
      display_label: 'Last name',
      matching_keywords: 'last_name',
      type: 'text',
      required: true,
    },
    {
      column_name: 'email',
      display_label: 'Email',
      matching_keywords: 'email',
      type: 'regex',
      required: false,
      validators: {
        expression: '/^.+@.+..+$/',
      },
    },
    {
      column_name: 'mobile',
      display_label: 'Mobile',
      matching_keywords: 'mobile',
      type: 'phone_number',
      required: false,
      validators: {
        country_code: 'au',
      },
    },
    {
      column_name: 'phone',
      display_label: 'Alternative phone',
      matching_keywords: 'phone, landline',
      type: 'phone_number',
      required: false,
      validators: {
        country_code: 'au',
      },
    },
    {
      column_name: 'street_address_1',
      display_label: 'Street Address',
      matching_keywords: 'street_address_1, address_1, address1, mailing_address',
      type: 'text',
      required: false,
    },
    ...(showAddress2 ? [address2Column] : []),
    {
      column_name: 'suburb',
      display_label: 'Suburb',
      matching_keywords: 'suburb, city',
      type: 'text',
      required: false,
    },
    {
      column_name: 'state',
      display_label: 'State',
      matching_keywords: 'state, province',
      type: 'text',
      required: false,
    },
    {
      column_name: 'postcode',
      display_label: 'Postcode',
      matching_keywords: 'postcode, zip',
      type: 'text',
      required: false,
    },
    {
      column_name: 'country',
      display_label: 'Country name or code',
      matching_keywords: 'country, country_name, country_code',
      type: 'text',
      required: false,
    },
    {
      column_name: 'tags',
      display_label: 'Tags',
      matching_keywords: 'tags, supporter_tags',
      type: 'text',
      required: false,
      info_hint: 'A list of zero or more comma delimited tags. Example: one, two, three',
    },
    ...(editFederalDistrict ? [federalDistrictColumn] : []),
    {
      column_name: 'email_opt_in',
      display_label: 'Email opt in',
      matching_keywords: 'email_opt_in, mobilemaile subscribe, email unsubscribe, email opt',
      type: 'boolean',
      required: false,
    },
    {
      column_name: 'mobile_opt_in',
      display_label: 'Mobile opt in',
      matching_keywords: 'mobile_opt_in, mobile subscribe, mobile unsubscribe, mobile opt',
      type: 'boolean',
      required: false,
    },
    {
      column_name: 'do_not_call',
      display_label: 'Do not call',
      matching_keywords: 'do_not_call, call_opt_out, call subscribe, call unsubscribe, call opt',
      type: 'boolean',
      required: false,
    },
    {
      column_name: 'do_not_contact',
      display_label: 'Do not contact',
      matching_keywords: 'do_not_contact, contact opt out, subscribe, unsubscribe, opt out',
      type: 'boolean',
      required: false,
    },
  ]
}
